import { css } from 'styled-components';

export const base = css`
  display: flex;
  align-items: center;

  & > a {
    text-transform: none;
  }
`;

export const sideBox = css`
  margin-left: 1rem;
`;
